import { createFileRoute } from "@tanstack/react-router";
import { opsHead } from "~/head";

export const Route = createFileRoute("/sign-in/$")({
  head: () => opsHead("Sign In"),
  // note: just here to catch all paths and render the layout
  component: () => null,
});
